import React from 'react';

const ImageModal = ({ selectedImage, handlePreviousImage, handleNextImage, setSelectedImage }) => {
  return (
    <div
      className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 flex items-center justify-center z-50"
      onTouchStart={(e) => {
        const touchStartX = e.changedTouches[0].clientX;
        e.currentTarget.ontouchend = (ev) => {
          const touchEndX = ev.changedTouches[0].clientX;
          if (touchEndX - touchStartX > 50) {
            handlePreviousImage();
          } else if (touchStartX - touchEndX > 50) {
            handleNextImage();
          }
        };
      }}
    >
      <div className="relative w-full h-full flex items-center justify-center">
        <button
          onClick={() => setSelectedImage(null)}
          className="absolute top-0 right-0 m-4 text-[#00f6ff] text-2xl"
        >
          &times;
        </button>
        <img src={`${process.env.PUBLIC_URL}/images/${selectedImage}`} alt="Full Image" className="w-full h-full object-contain" />
        <div className="absolute top-0 left-0 m-4 flex gap-4">
          <button onClick={handlePreviousImage} className="bg-black p-2 border border-[#00f6ff] rounded text-[#00f6ff] hover:bg-[#000000] hover:text-[#000000]">
            Previous
          </button>
          <button onClick={handleNextImage} className="bg-black p-2 border border-[#00f6ff] rounded text-[#00f6ff] hover:bg-[#000000] hover:text-[#000000]">
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;